export const Coin = (props) => (
    <svg {...props} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32.4854" cy="32.4854" r="11.75" fill="url(#paint0_linear_149_2143)" stroke="white" strokeWidth="2.76471"/>
        <circle cx="21.4265" cy="22.8089" r="11.75" fill="url(#paint1_linear_149_2143)" stroke="white" strokeWidth="2.76471"/>
        <path d="M13.8235 22.8088C13.8235 18.6098 17.2274 15.2058 21.4264 15.2058" stroke="white" strokeWidth="2.76471" strokeLinecap="round"/>
        <defs>
        <linearGradient id="paint0_linear_149_2143" x1="40.9836" y1="21.0189" x2="19.1966" y2="29.7781" gradientUnits="userSpaceOnUse">
        <stop stopColor="#BC6BF4"/>
        <stop offset="0.325" stopColor="#8C96F6"/>
        <stop offset="0.635" stopColor="#58C8FF"/>
        <stop offset="1" stopColor="#14EAB0"/>
        </linearGradient>
        <linearGradient id="paint1_linear_149_2143" x1="29.9248" y1="11.3424" x2="8.13775" y2="20.1015" gradientUnits="userSpaceOnUse">
        <stop stopColor="#BC6BF4"/>
        <stop offset="0.325" stopColor="#8C96F6"/>
        <stop offset="0.635" stopColor="#58C8FF"/>
        <stop offset="1" stopColor="#14EAB0"/>
        </linearGradient>
        </defs>
    </svg>
)
